import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo_sm.png'


const _hoisted_1 = { class: "flex flex-col items-center gap-1 2xl:gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "w-16 mb-2 2xl:w-24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-light text-gray-500 2xl:text-2xl" }, "Piscicultura", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-light text-gray-500 2xl:text-3xl" }, " Águas da Olaria ", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}